export default "__VITE_ASSET__BK6M99$I__"